import { render, staticRenderFns } from "./SpuPlatform.vue?vue&type=template&id=271817d6&scoped=true"
import script from "./SpuPlatform.vue?vue&type=script&lang=ts"
export * from "./SpuPlatform.vue?vue&type=script&lang=ts"
import style0 from "./SpuPlatform.vue?vue&type=style&index=0&id=271817d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271817d6",
  null
  
)

export default component.exports